// extracted by mini-css-extract-plugin
module.exports = {"Label":"OptIn-Label-20Ntk6","SmallPrint":"OptIn-SmallPrint-3Q8W7V","SignUpWrap":"OptIn-SignUpWrap-1JEU6m"};